import React, { Component, Fragment } from "react";
import { injectIntl } from 'react-intl';
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import API from '../../../../api/index'
var classNames = require('classnames');
import ReactTimeAgo from 'react-time-ago'
import { NotificationManager } from "Components/ReactNotifications";
import moment from 'jalali-moment'

import {
    logoutUser
} from "Redux/actions";
import { connect } from "react-redux";
import CustomSelectInput from "Components/CustomSelectInput";
import Select from "react-select";
import {
    Row,
    Card,
    CardBody,
    CardTitle,
    Button,
    Collapse,
    FormGroup,
    Label,
    Input,
    Form,
    timeoutsShape
} from "reactstrap";


import NumberFormat from 'react-number-format';
import { Colxx, Separator } from "Components/CustomBootstrap";


class archive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Operators: [],
            LeadPendings: [],
            paging: [],
            isRefreshing: false,
            isLoading: true,
            toggleSearchForm: false,
            APIResetData: {},
            APISearchData: {},
            search: {
                processed: "ALL",
                processResult: "ALL",
                operatorID: "ALL",
                leadMobile: "",
                currentPage: 1,
                createdFrom: "",
                createdTo: ""
            }
        };



        this.validateMobile = this.validateMobile.bind(this);
        this.setCreatedDateRange = this.setCreatedDateRange.bind(this);
        this.setClosedDateRange = this.setClosedDateRange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.toggleSearchForm = this.toggleSearchForm.bind(this);
        this.doSearch = this.doSearch.bind(this);
        this.doReset = this.doReset.bind(this);
        this.cleanCustomerMobile = this.cleanCustomerMobile.bind(this);
        this.loadData = this.loadData.bind(this);


    }

    cleanCustomerMobile(mobile) {
        mobile = mobile.split(" ").join("");
        mobile = mobile.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

        // console.log(mobile,mobile.indexOf("0098"))
        if (mobile.indexOf("0098") === 0) {
            mobile = mobile.replace("0098", "0");
        }
        if (mobile.indexOf("098") === 0) {
            mobile = mobile.replace("098", "0");
        }
        if (mobile.indexOf("+98") === 0) {
            mobile = mobile.replace("+98", "0");
        }
        if (mobile.indexOf("98") === 0) {
            mobile = mobile.replace("98", "0");
        }
        if (mobile.indexOf("9") === 0 && mobile.length == 10) {
            mobile = "0" + mobile;
        }
        return mobile;
    }
    componentDidMount() {
        this.setState({
            APISearchData: JSON.parse(JSON.stringify(this.state.search)),
            APIResetData: JSON.parse(JSON.stringify(this.state.search))
        }, () => {
            API.operator.list({ "role": "operator" })
                .then(data => {
                    (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                    this.setState({
                        Operators: data.Operators,
                    }, () => {
                        this.loadData();
                    });
                })
                .catch(error => { });

        })
    }
    loadData() {
        API.crm.lead.listpending(this.state.APISearchData)
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                this.setState({
                    LeadPendings: data.LeadPendigns,
                    paging: data.paging,
                    isLoading: false,
                    isRefreshing: false
                });
            })
            .catch(error => { });
    }
    doSearch() {
        var tmpObj = JSON.parse(JSON.stringify(this.state.search));
        tmpObj.currentPage = 1;
        this.setState({
            APISearchData: tmpObj,
            isRefreshing: true
        },
            () => {
                this.loadData();
            });
    }
    doReset() {
        this.setState({
            search: JSON.parse(JSON.stringify(this.state.APIResetData)),
            APISearchData: JSON.parse(JSON.stringify(this.state.APIResetData)),
            isRefreshing: true
        }, () => {
            this.loadData();
        });
    }
    handleFocus = (event) => event.target.select();
    setCreatedDateRange(start, end) {
        var tmpObj = this.state.search;
        tmpObj.createdFrom = start;
        tmpObj.createdTo = end;
        this.setState({ search: tmpObj });
    }
    setClosedDateRange(start, end) {
        var tmpObj = this.state.search;
        tmpObj.closedFrom = start;
        tmpObj.closedTo = end;
        this.setState({ search: tmpObj });
    }
    validateMobile(mobile) {
        if (mobile.trim() == "") {
            return false;
        }
        return mobile.match(/^(0)+(9|$)\d{9}$/g) != null;
    }
    toggleSearchForm() {
        const prevState = this.state.toggleSearchForm;
        this.setState({
            toggleSearchForm: !prevState
        });
    }

    render() {

        return (
            this.state.isLoading ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row className="mb-4 searchdropdown">
                        <Colxx xxs="12">
                            <Card>
                                <CardBody>
                                    <CardTitle>
                                        <div onClick={(e) => { this.props.history.push("/app/crm/lead/"); }} className="breadcrumb-item">
                                            <div className={"iconsminds-leaning-tower headingicon"} /> سرنخ ها
                                        </div>
                                        <span className="breadcrumb-arrow" style={{ marginLeft: "10px" }}>{" > "}</span>
                                        <div className={"iconsminds-data-center headingicon"} />
                                        لیست شماره های ثبت یا حذف اتوماتیک سرنخ

                                        <div className={'text-muted'} style={{ float: "left", fontSize: "14px" }}>
                                            {" نمایش "}
                                            {<NumberFormat value={this.state.paging.from + 1} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                            {" تا "}
                                            {<NumberFormat value={this.state.paging.to} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                            {" از "}
                                            {<NumberFormat value={this.state.paging.total} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                            {" سرنخ"}
                                        </div>
                                    </CardTitle>

                                    <Fragment>
                                        <div className="border productPanel">
                                            <Button
                                                block
                                                color="link"
                                                className="text-right"
                                                onClick={() => this.toggleSearchForm()}

                                                aria-expanded={this.state.toggleSearchForm}
                                            >
                                                <i className="glyph-icon simple-icon-magnifier" style={{ "marginLeft": "5px", "fontSize": "14px" }}></i>


                                                فرم جستجو
                                                <i className="glyph-icon simple-icon-arrow-down" style={{ "marginRight": "10px", "fontSize": "10px" }}></i>

                                            </Button>
                                            <div className="dropdown-buttons" style={{ float: "left", display: this.state.toggleSearchForm ? "inline-block" : "none" }}>

                                                <Button color="primary" style={{ "float": "left" }} className={"default"} onClick={this.doSearch}>
                                                    جستجو کن
                                                </Button>
                                                <Button color="light" style={{ "float": "left", "marginLeft": "10px" }} className={"default"} onClick={this.doReset}>
                                                    ریست
                                                </Button>
                                            </div>
                                            <Collapse isOpen={this.state.toggleSearchForm}>
                                                <div className="p-4">

                                                    <Row className="mb-4">
                                                        <Colxx xxs="12">

                                                            <Form>
                                                                <FormGroup row>
                                                                    <Colxx sm={3}>
                                                                        <FormGroup className={"filter " + ((this.validateMobile(this.state.search.leadMobile)) ? "filter-active" : "")}>
                                                                            <Label for="leadMobile">
                                                                                موبایل سرنخ ( شروع با )
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="leadMobile"
                                                                                id="leadMobile"
                                                                                onClick={this.handleFocus}
                                                                                placeholder="09123456789"
                                                                                value={this.state.search.leadMobile}
                                                                                onChange={(e) => { var cleanValue = this.cleanCustomerMobile(e.target.value); var tmpObj = { ...this.state.search }; tmpObj.leadMobile = cleanValue; this.setState({ search: tmpObj }); }}

                                                                            />
                                                                        </FormGroup>
                                                                        <FormGroup className={"filter " + ((this.state.search.operatorID != "ALL") ? "filter-active" : "")}>
                                                                            <Label>
                                                                                اپراتور
                                                                            </Label>
                                                                            <Input type="select"

                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.operatorID = e.target.value; this.setState({ search: tmpObj }); }}
                                                                                value={this.state.search.operatorID}
                                                                            >
                                                                                <option value="ALL">همه</option>
                                                                                {this.state.Operators.map((operator, index) => (
                                                                                    <option value={operator.OperatorID} key={index}>{operator.Name}</option>
                                                                                ))}

                                                                            </Input>

                                                                        </FormGroup>

                                                                    </Colxx>

                                                                    <Colxx sm={3}>
                                                                        <FormGroup className={"filter " + ((this.state.search.processed != "ALL") ? "filter-active" : "")}>
                                                                            <Label>
                                                                                وضعیت پردازش
                                                                            </Label>
                                                                            <Input type="select"

                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.processed = e.target.value; this.setState({ search: tmpObj }); }}
                                                                                value={this.state.search.processed}
                                                                            >
                                                                                <option value="ALL" >همه وضعیت ها</option>
                                                                                <option value="PROCESSED" >فقط پردازش شده ها</option>
                                                                                <option value="NOT_PROCESSED">فقط پردازش نشده ها</option>
                                                                            </Input>

                                                                        </FormGroup>

                                                                        <FormGroup className={"filter " + ((this.state.search.processResult != "ALL") ? "filter-active" : "")}>
                                                                            <Label>
                                                                                نتیجه پردازش
                                                                            </Label>
                                                                            <Input type="select"

                                                                                onChange={(e) => { var tmpObj = { ...this.state.search }; tmpObj.processResult = e.target.value; this.setState({ search: tmpObj }); }}
                                                                                value={this.state.search.processResult}
                                                                            >
                                                                                <option value="ALL" >همه نتیجه ها</option>
                                                                                <option value="CUSTOMER" >مشتری</option>
                                                                                <option value="LEAD + PULSE">سرنخ جدید و پالس</option>
                                                                                <option value="PULSE">فقط پالس</option>
                                                                            </Input>

                                                                        </FormGroup>
                                                                    </Colxx>
                                                                    <Colxx sm={3}>
                                                                        <FormGroup className={"filter " + ((this.state.search.createdFrom != "" && this.state.search.createdTo != "") ? "filter-active" : "")}>
                                                                            <Button style={{ "float": "left", "padding": "5px", "color": "black", "backgroundColor": "transparent", "border": "unset", "display": ((this.state.search.createdFrom != "" && this.state.search.createdTo != "")) ? "block" : "none" }} onClick={(e) => { var tmpObj = { ...this.state.search }; tmpObj.createdFrom = ""; tmpObj.createdTo = ""; this.setState({ search: tmpObj }); }}>
                                                                                <i className="simple-icon-close"></i>
                                                                            </Button>
                                                                            <RangeDatePicker fromLabel="ثبت شده از تاریخ" toLabel="ثبت شده تا تاریخ" onClickSubmitButton={this.setCreatedDateRange} />
                                                                        </FormGroup>
                                                                    </Colxx>

                                                                </FormGroup>
                                                            </Form>
                                                        </Colxx>
                                                    </Row>

                                                </div>
                                            </Collapse>
                                        </div>
                                        <br />
                                    </Fragment>
                                    {!this.state.isRefreshing ?
                                        <div className="table-responsive">
                                            <table className="table table-hover order-table">
                                                <thead>
                                                    <tr>
                                                        <th>شماره سرنخ</th>
                                                        <th>زمان ثبت</th>
                                                        <th>موبایل</th>
                                                        <th>پالس </th>
                                                        <th>پردازش  </th>
                                                        <th>نتیجه </th>
                                                        <th>اپراتور</th>
                                                    </tr>

                                                </thead>

                                                {this.state.LeadPendings.map(row => (
                                                    <TableBodyRows
                                                        key={row.LeadPendingID}
                                                        data={row}
                                                    />
                                                ))}

                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="table-pagination">
                                                                {this.state.paging.pages.map((page, index) => (
                                                                    <Button key={index} className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })} onClick={(e) => { if (page.ellipse) { return; } var tmpObj = { ...this.state.APISearchData }; tmpObj.currentPage = page.page; this.setState({ APISearchData: tmpObj, isRefreshing: true }, () => { this.loadData() }); }}  >
                                                                        {page.page}
                                                                    </Button>
                                                                ))}


                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        : <div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>}
                                </CardBody>
                            </Card>
                        </Colxx>
                    </Row>
                </Fragment >
        );
    }
}

class TableBodyRows extends Component {

    render() {
        const {
            data: { LeadPendingID, CreatedAt, Processed, LeadPendingMobile, PulseTagID, Pulse, ProcessResult, OperatorName },

        } = this.props;
        var ProcessResultsMap = [];
        ProcessResultsMap['CUSTOMER'] = "مشتری شد";
        ProcessResultsMap['LEAD + PULSE'] = "تبدیل به سرنخ شد";
        ProcessResultsMap['PULSE'] = "پالس جدید ثبت شد";
        return (
            <tbody>
                <tr className={"order-spacer"}>

                </tr>
                <tr className={"order-item"}>


                    <td className={"text-muted"}>{LeadPendingID}</td>
                    <td className={"text-muted"}>{moment(CreatedAt).locale('fa').format('DD / MMMM / YYYY - HH:mm')}</td>
                    <td>{Processed === "1" ?
                        <a target="_blank" href={ProcessResult == "CUSTOMER" ? "/app/customers/view-customer/" + LeadPendingMobile : "/app/crm/lead/view/" + LeadPendingMobile} >
                            {LeadPendingMobile} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
                        </a>
                        : <span>{LeadPendingMobile}</span>}
                    </td>
                    <td className={"text-muted"}>
                        <ul className={"pulses"}>
                            <li >{Pulse} </li>
                        </ul>
                    </td>
                    <td className={"text-muted"}><div className={
                        classNames({
                            "simple-icon-check": (Processed === "1"),
                            "simple-icon-options": (Processed === "0")
                        })} /></td>
                    <td className={"text-muted"}>
                        <div title={ProcessResultsMap[ProcessResult]} className={
                            classNames({
                                "iconsminds-business-man-woman": (ProcessResult === "CUSTOMER"),
                                "iconsminds-leaning-tower": (ProcessResult === "LEAD + PULSE"),
                                "iconsminds-pulse": (ProcessResult === "PULSE")
                            })} style={{ fontSize: "26px", fontWeight: "bold", height: "26px" }} />
                    </td>
                    <td className={"text-muted"}>{OperatorName}</td>
                </tr>

            </tbody>
        );
    }
}

const mapStateToProps = ({ menu, settings }) => {
    return { logoutUser };
};
export default injectIntl(connect(
    mapStateToProps,
    { logoutUser }
)(archive));
// export default injectIntl(archive);